import { ContentControlWebAccessRule } from '@nirvana/shared/dtos/types/policies/common';

export function sanitizeExclusionItemFormValue(item: ContentControlWebAccessRule): any {
  let webAddress = item.webAddress;
  webAddress = webAddress.replace('https://', '');
  webAddress = webAddress.replace('http://', '');

  return {
    ...item,
    webAddress: webAddress,
  };
}
